import axios from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'

import { IsAuthorized } from 'src/authentication/IsAuthorized'

class ItemSupplierServices {
  async getByParam(params: object): Promise<any> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/item-supplier/`, {
        headers: { 'authentication-token': getJWT()! },
        params: params,
      })
      return {data:res.data, total:res['headers']['row-counter']}
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getTransactions(params: object): Promise<any> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/supplier-payment-order/with-payment/`, {
        headers: { 'authentication-token': getJWT()! },
        params: params,
      })
      return {data:res.data, total:res['headers']['row-counter']}
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getInvoicesByItem(body: object): Promise<any> {
    try {
      const res = await axios.post(`${process.env.REACT_APP_URL_RESERVATION}/invoice/provider/by-item/`, body, {
        headers: { 'authentication-token': getJWT()! }
      })
      return {data:res.data, total:res['headers']['row-counter']}
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async deleteAttatchmentInvoice(invoice_id: number): Promise<any> {
    try {
      const res = await axios.delete(`${process.env.REACT_APP_URL_RESERVATION}/invoice/attachment/${invoice_id}`, {
        headers: { 'authentication-token': getJWT()! }
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async uploadFileInvoice(body: FormData): Promise<any> {
    try {
      const res = await axios.post(`${process.env.REACT_APP_URL_RESERVATION}/invoice/attachment/`, body, {
        headers: { 'authentication-token': getJWT()! }
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async createPayment(body: object): Promise<any> {
    try {
      const res = await axios.post(`${process.env.REACT_APP_URL_PAYMENT}/payment-entity/supplier-payment-order/`, body, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async deletePayments(supplier_payment_order_id:number): Promise<any> {
    try {
      const res = await axios.put(`${process.env.REACT_APP_URL_RESERVATION}/supplier-payment-order-detail/cancel/${supplier_payment_order_id}`, {} ,{
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}
export const itemSupplierServices = new ItemSupplierServices()